<script>
import { fandomBasicMixin, fandomExtendedMixin } from 'src/modules/fandom_mixins_module.js';
import { vodafoneLabBasicMixin } from "../../modules/vodafone_lab_mixins_module.js";
import { VodafoneLab } from "../../modules/vodafone_lab_module.js";

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin, vodafoneLabBasicMixin],
  methods: {
    getContent: Fandom.getContent,
    appendContents() {
      VodafoneLab.addDigitalDataEvent("search_results_clicktrough", "search", ":Search apply");
      if (!!this.alternativeAppendContents) {
        this.alternativeAppendContents();
      } else {
        Fandom.appendContents(this.content.name, null, (this.content.limit || 8), this.appendContentsParams);
      }
    },
  },
  computed: {
    columnClasses() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : Fandom.retrieveFromGlobalState("one_col_text_width", 7);
      return [
        `col-lg-${columnWidth}`
      ];
    },
  }
};
</script>

<template>
  <div 
    v-if="isContentVisibleToUser()" 
    v-easyadmin="easyadminId" 
    :class="contentType" 
    page-collections-component
    class="position-relative"
  >
    <div class="d-flex align-items-center page-header position-relative">
      <div class="container px-md-4">
        <div class="row py-3 py-md-5 justify-content-center">
          <div class="col-12 col-md-9 col-lg-6 text-center py-4" v-if="content.title">
            <h2 class="h1 mt-3" v-if="content.title">{{content.title}}</h2>
            <h4 v-html="content.description"></h4>
          </div>
        </div>
      </div>
    </div>
    <div class="container my-4 my-md-5 pt-md-5">
      <div class="row">
        <div class="col-12 px-sm-0 grid">
          <component
            :is="child.layout || 'tile'"
            :content="getContent(child)"
            v-for="child in content.children"
            :forceMobileThumbnail="true"
            :key="`item-${getContent(child).name}`"
            class="item"
          ></component>
        </div>
      </div>
    </div>
    <div v-if="content.has_more_children" class="container my-4 my-md-5">
      <div class="row">
        <div class="col-sm-12 text-center">
          <button class="btn shadow-none" :class="themeButtonClass" @click="appendContents()">{{ft("globals.load_more")}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[page-collections-component] {

  .page-header {
    background: rgb(238,238,238);
  }

  [tile-component] {
    .link-label {
      &.text-primary {
        color: $dark !important;
      }
    }

    .tile__category {
      border-radius: 3rem;
  
      &.primary {
        background-color: #fff;
        color: $dark;
      }
    }
  }

  .grid {
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-flow: row dense;
    grid-auto-rows: 1fr;
    grid-gap: 1.5rem;
    display: grid;

    .item {
      grid-row: span 1;
      grid-column: span 1;
      padding-bottom: 150%;
      position: relative;

      & > div {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
      }
    }

    @include media-breakpoint-down(sm) {
      grid-template-columns: 1fr;
    }
  }

  .layer {
    background-color: rgba(0,0,0,.25);
  }
}
</style>
